import { Injectable } from '@angular/core';
import { RequestsServices } from './requests.service';

@Injectable()
export class CostCenterService {

    constructor(
        public request: RequestsServices
    ) { }

    public getCostCenters(params): any {
        return this.request.get({ path: 'cost_center', endPoint: 'searchFilters', params  });
    }

    public createCostCenters(data): any {
        return this.request.post('cost_center', data);
    }

    public updateCostCenters(id, data): any {
        return this.request.patch('cost_center', data, '', `/${id}`);
    }

    public deleteCostCenters(id): any {
        return this.request.delete('cost_center', '', `/${id}`);
    }

    public getAddressTypes(): any {
        return this.request.get({ path: 'addressTypes'});
    }
}
